import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Paginate } from './paginator'

const Outer = styled.div`
  display: flex;
  align-items: center;
`

const Item = styled.div`
  display: block;
  padding: 1rem;
  color: #aaa;
  &:hover {
    text-decoration: underline;
  }
`

const ActiveItem = styled(Item)`
  color: #7a6ea0;
  &:hover {
    text-decoration: none;
  }
`

const Spread = styled.div``

type PostPaginatorProps = {
  pageCount: number
  currentPage: number
  linkGenerator: (page: number) => string
}
export const PostPaginator: FunctionComponent<PostPaginatorProps> = ({pageCount, currentPage, linkGenerator}) => {
  return <Outer>
    <Paginate
      pageCount={pageCount}
      currentPage={currentPage}
      linkBuilder={
        ({page, active}) => active ? <ActiveItem>{page}</ActiveItem> : <Item as={Link} to={linkGenerator(page)}>{page}</Item>
      }
      spreadBuilder={() => <Spread>…</Spread>}
    />
  </Outer>
}